var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "out-container" }, [
    _c("div", { staticClass: "bg-color-area", attrs: { id: "bg-color" } }, [
      _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg, alt: "" } }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "download-source" }, [
        _c(
          "a",
          {
            staticClass: "app-store",
            attrs: {
              href: "https://apps.apple.com/app/apple-store/id6498875759",
            },
          },
          [
            _c("img", {
              attrs: { src: _vm.appstoreImg, alt: "Kimy App Store" },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "google-play",
            attrs: {
              href: "https://play.google.com/store/apps/details?id=com.mico.lite.android",
            },
          },
          [
            _c("img", {
              attrs: { src: _vm.googleplayImg, alt: "Kimy Google Play" },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "mico-lite-logo" }, [
            _c("img", {
              staticClass: "img-responsive",
              attrs: { src: _vm.logoImg, alt: "Kimy Logo" },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-8" },
          _vm._l(_vm.banners, function (banner, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "txt-caption",
                attrs: { id: "txtCaptionPg" + (index + 1) },
              },
              [
                _c("p", { staticClass: "txt-title" }, [
                  _vm._v(_vm._s(banner.title)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "txt-detail" }, [
                  _vm._v(_vm._s(banner.desc)),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-4" }, [
          _c(
            "div",
            { attrs: { id: "inner-container" } },
            _vm._l(_vm.banners, function (banner, idx) {
              return _c("div", { key: "s" + idx, staticClass: "section" }, [
                _c("img", { attrs: { src: _vm.pageImages[idx] } }),
              ])
            }),
            0
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("nav", { staticClass: "nav-end navbar" }, [
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "mico-lite-navbar-collapse-1" },
        },
        [
          _c("ul", { staticClass: "nav navbar-nav" }, [
            _c("li", [
              _c(
                "a",
                { attrs: { href: "/kimy/terms.html", target: "_blank" } },
                [_vm._v("Terms")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("|")])]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                { attrs: { href: "/kimy/privacy.html", target: "_blank" } },
                [_vm._v("Privacy")]
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }